module.exports = __webpack_public_path__ + "bg912-16b3afb88eee8153d5bdcc5abc56c102.png";